'use strict';
import React from 'react';
import { useHistory } from 'react-router-dom';
import './LoginButton.scss';
import { Link, Material } from '../../components/index.jsx';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';

export const LoginButton = () => {
	const history = useHistory();
	const isAuthenticated = useIsAuthenticated();

	const handleLogin = () => {
		history.push("/login");
	};

	const handleGoHome = () => {
		history.push("/home");
	};

	if (isAuthenticated) {
		return (
			<Link size="normal" className="login" alt={true} color="primary" onClick={handleGoHome}>
				Home&nbsp;<Material icon={'person_outline'} color={'primary'} />
			</Link>
		);
	}
	else {
		return (
			<Link size="normal" className="login" alt={true} color="primary" onClick={handleLogin}>
				Sign In&nbsp;<Material icon={'person_outline'} color={'primary'} />
			</Link>
		);
	}
};

export default LoginButton;